import { render, staticRenderFns } from "./BusinessNameAmendmentEscalations.vue?vue&type=template&id=e6d4e942&scoped=true&"
import script from "./BusinessNameAmendmentEscalations.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAmendmentEscalations.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAmendmentEscalations.vue?vue&type=style&index=0&id=e6d4e942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d4e942",
  null
  
)

export default component.exports